import { FadeIn } from "@/components/FadeIn";
import { Button } from "@/components/ui/button";

const WITHOUT = [
  "You rely on scattered information from different sources.",
  "Seasonal questions can be difficult to answer without the right resources.",
  "Plans, budgets, and records need to be created and updated on your own.",
  "Finding reliable guidance can take time.",
];

const WITH = [
  "You access a growing, Alberta-specific library of guides and resources.",
  "Seasonal updates help you prepare for changes throughout the year.",
  "Templates and record-keeping tools help you organize your pond management.",
  "Guidance is available whenever you need it.",
];

export const Membership = () => {
  const scrollTo = () => {
    const el = document.querySelector("#book");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="membership" data-testid="membership-section" className="bg-[color:var(--apn-paper-2)]">
      <div className="mx-auto w-full max-w-[1280px] px-5 sm:px-8 pt-[40px] pb-[50px] lg:pt-20 lg:pb-10">
        <FadeIn>
          <h2 className="font-serif-heading font-medium text-4xl sm:text-5xl lg:text-[clamp(2.25rem,2.9vw+0.5rem,3.4rem)] leading-[1.05] tracking-[-0.015em] text-foreground">
            Join the network.
          </h2>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-foreground/65 max-w-[56ch] lg:max-w-none">
            Pond aquaculture is a long game, and it's easier in good company.
            <br className="hidden lg:block" /> Membership is a subscription to understanding, each renewed season as your pond changes.
          </p>
        </FadeIn>

        {/* Editorial comparison */}
        <FadeIn delay={0.08}>
          <div className="mt-[46px] sm:mt-16 relative grid grid-cols-1 md:grid-cols-2 gap-y-[33px] md:gap-y-0">
            <span
              className="hidden md:block absolute left-1/2 top-1 bottom-6 w-px bg-[color:var(--apn-border)]"
              aria-hidden="true"
            />
            <div data-testid="membership-without-column" className="md:pr-14 lg:pr-20">
              <h3 className="font-serif-heading text-xl sm:text-2xl font-medium text-foreground/55">
                Without membership
              </h3>
              <ul className="mt-6">
                {WITHOUT.map((line, i) => (
                  <li
                    key={line}
                    data-testid={`membership-without-${i + 1}`}
                    className="hairline py-5 text-sm sm:text-[15px] leading-[1.75] text-foreground/55"
                  >
                    {line}
                  </li>
                ))}
              </ul>
            </div>

            <div data-testid="membership-with-column" className="md:pl-14 lg:pl-[70px]">
              <h3 className="font-serif-heading text-xl sm:text-2xl font-medium text-foreground">
                With membership
              </h3>
              <ul className="mt-6">
                {WITH.map((line, i) => (
                  <li
                    key={line}
                    data-testid={`membership-with-${i + 1}`}
                    className="hairline py-5 text-sm sm:text-[15px] leading-[1.75] text-foreground/80"
                  >
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.12}>
          <div className="mt-[28px] sm:mt-14 flex flex-wrap items-center gap-5 lg:justify-center">
            <Button
              data-testid="membership-cta-button"
              onClick={scrollTo}
              className="btn-lift rounded-none bg-[color:var(--apn-forest)] text-[color:var(--apn-paper-2)] hover:bg-[color:var(--apn-forest-2)] h-12 px-8 text-[15px]"
            >
              Express interest
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};
